import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledMenu = /*#__PURE__*/_styled(Paper, {
  shouldForwardProp: isStyledPropsValid,
  target: "edbsovj1"
})(_ref => {
  let {
    theme,
    paperStyle,
    maxHeight
  } = _ref;
  return {
    '&.MuiPaper-root': _objectSpread2({
      borderRadius: 6,
      background: theme.customColors.white,
      marginTop: theme.spacing(1),
      minWidth: 90,
      overflow: 'auto',
      maxHeight,
      color: theme.customColors.grey[300],
      boxShadow: 'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiList-root': {
        padding: '4px'
      },
      '& .MuiMenuItem-root': {
        color: theme.customColors.grey[700],
        size: '13px',
        padding: '8px 14px',
        '&.Mui-focusVisible': {
          backgroundColor: 'unset'
        },
        '& i': {
          marginRight: '4px'
        },
        '&:hover': {
          background: theme.customColors.purple[300]
        }
      }
    }, paperStyle)
  };
}, "");
const StyledMenuItem = /*#__PURE__*/_styled(MenuItem, {
  shouldForwardProp: isStyledPropsValid,
  target: "edbsovj0"
})(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    '&.MuiButtonBase-root': {
      '&.MuiMenuItem-root': {
        color: theme.customColors.grey[800],
        '& svg': {
          color: theme.customColors.grey[500]
        },
        '& i': {
          color: theme.customColors.grey[500]
        },
        '&:hover': {
          color: theme.customColors.purple[600],
          backgroundColor: theme.customColors.purple[300],
          '& svg': {
            color: theme.customColors.purple[600]
          },
          '& i': {
            color: theme.customColors.purple[600]
          }
        }
      }
    }
  };
}, "");
export { StyledMenu, StyledMenuItem };